export default __webpack_public_path__ + "static/media/favicon.2b948d02.ico";